export default __webpack_public_path__ + "static/okremote_2-617f2089febca1c53210e1af657de37c.jpg";